export default __webpack_public_path__ + "static/media/DiscoveryFirstViewIcon.889b9267.svg";